<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div>
    <div class="echarts" id="echarts-dom" ref="echarts-bar"></div>
  </div>
</template>

<script>
export default {
  name: "echarts",
  props: {
    xData: {
      type: Array,
      default() {
        return [];
      }
    },
    yData: {
      type: Array,
      default() {
        return [0, 0, 0, 0, 0, 0];
      }
    }
  },
  data() {
    return {};
  },
  watch: {
    xData() {
      this.createEcharts();
    }
  },
  mounted() {
    this.createEcharts();
  },
  methods: {
    createEcharts() {
      let barHeght = this.$refs["echarts-bar"].clientHeight * 0.68;
      let $echartsDOM = document.getElementById("echarts-dom");
      let myEcharts = this.$echarts.init($echartsDOM);
      let option = {
        color: "#F5A623", //设置柱子颜色
        grid: {
          top: "10%",
          left: "8%",
          right: "0",
          bottom: "10%",
          containLabel: false,
          height: barHeght
        },
        xAxis: {
          type: "category",
          data: this.xData,
          axisLabel: {
            show: true,
            interval: 0,
            rotate: 30,
            fontSize: 13
          },
          axisTick: {
            show: false
          },
          axisLine: {
            symbol: ["none", "arrow"],
            symbolSize: [5, 7],
            lineStyle: {
              color: "#89939F"
            }
          }
        },
        yAxis: {
          name: "100分",
          nameLocation: "center",
          type: "value",
          max: 100,
          nameGap:5,
          axisLabel: {
            show: false,
            fontSize: 13
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            symbol: ["none", "arrow"],
            symbolSize: [5,7],
            lineStyle: {
              color: "#89939F"
            }
          }
        },
        series: [
          {
            data: this.yData,
            type: "bar",
            // barCategoryGap: '80%', //调整柱子宽度
            barWidth: 16,
            itemStyle: {
              emphasis: {
                barBorderRadius: 7
              },
              normal: {
                barBorderRadius: 7,
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#F5A623",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
      myEcharts.setOption(option);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/echarts_bar/index.vue